import * as React from 'react';
import { observer } from 'mobx-react';

import ModalReactions from '../../../../../Modal/ModalReactions';
import VideoProjectFeedbackModal, { Props } from './VideoProjectFeedbackModal';

const VideoProjectFeedbackDetails: React.FC<Props> = (props) => (
  <>
    <VideoProjectFeedbackModal {...props} />
    <ModalReactions store={props.modalStore} />
  </>
);

export default observer(VideoProjectFeedbackDetails);
